import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TableSortLabel,
} from "@material-ui/core";
import PlaceOrderClass from "../StageOne/PlaceOrderClass.js";
import OrderWeightIcons from "../StageOne/OrderWeightIcons.js";
import OrderProductsTable from "../StageOne/OrderProductsTable.js";
import StageOneNextBackButtons from "../StageOne/StageOneNextBackButtons";
import { useSelector } from "react-redux";

// styling
import orderStageOne from "../../../../../assets/jss/CustomerTradePortal/views/OrderProcessPageSections/orderSageOnePageStyle.js";
import tableStyle from "../../../../../assets/jss/material-kit-pro-react/components/tableStyle.js";
import StepperView from "../../../Common/stepperPage.js";
import LoadingData from "../../../../views/lottieLoading.js";
const useStyles = makeStyles(orderStageOne);
const useTableStyle = makeStyles(tableStyle);

export default function OrderStageOnePage() {
  const loading = useSelector((state) => state.orderReducer.productLoading);
  const selectedQuoteId = useSelector((state) => state.orderReducer.selectedQuoteId);
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();
  const tbclass = useTableStyle();

  const customHeadCellClasses = [
    classes.textRight,
    classes.textCenter,
    classes.textCenter,
  ];
  const customHeadClassesForCells = [0, 4, 5];

  // Table header
  const headCells = [
    {
      id: "0",
      numeric: false,
      disablePadding: true,
      name: "Product Code",
      sortItemCode: "pcode",
    },
    {
      id: "1",
      numeric: false,
      disablePadding: false,
      name: "Product Name",
      sortItemCode: "name",
    },
    {
      id: "2",
      numeric: true,
      disablePadding: false,
      name: "Packs",
      sortItemCode: "packs",
    },
    {
      id: "3",
      numeric: true,
      disablePadding: false,
      name: "Total Weight (Tonnes)",
      sortItemCode: "totalWeight",
    },
    {
      id: "4",
      numeric: true,
      disablePadding: false,
      name: "Pack Size",
      sortItemCode: "packSize",
    },
    {
      id: "5",
      numeric: true,
      disablePadding: false,
      name: "Weight (Tonnes)",
      sortItemCode: "weight",
    },
    {
      id: "6",
      numeric: true,
      disablePadding: false,
      name: "Quantity",
      sortItemCode: "quantity",
    },
  ];

  //Table sorting
  const useSortableData = (items, config = null) => {
    const [sortConfig, setSortConfig] = React.useState(config);

    const [productList, setProductList] = React.useState(items); // populating product list and setProductList is used to update the (productList) state

    const sortedItems = React.useMemo(() => {
      let sortableItems = [...items];
      if (sortConfig !== null) {
        sortableItems.sort((a, b) => {
          if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
          return 0;
        });
      }
      setProductList(sortableItems);
      return sortableItems;
    }, [items, sortConfig]);

    const requestSort = (key) => {
      let direction = "ascending";
      if (
        sortConfig &&
        sortConfig.key === key &&
        sortConfig.direction === "ascending"
      ) {
        direction = "descending";
      }
      setSortConfig({ key, direction });
    };

    const requestChange = (key) => {
      let defaultTable = sortedItems.slice();
      let x = key.target;
      /*   console.log(x.value, rows);*/

      if (x.value === "") setProductList(defaultTable);
      else {
        const updatedList = defaultTable.filter((item) => {
          return item.pcode.toLowerCase().search(x.value.toLowerCase()) !== -1;
        });

        let filterList = [...updatedList];
        setProductList(filterList);
      }
    };

    return { items: productList, requestSort, sortConfig, requestChange };
  };

  return (
    <div style={{ width: "100%" }}>
      <br />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.contactContent}>
          <div className={classes.container}>
            <StepperView stepValue={0} />
            <div style={{ padding: "10x" }}>
              <h3 style={{ borderBottom: "2px dashed grey", padding: "5px" }}>
                Order Details
              </h3>
              <PlaceOrderClass />
              {(selectedQuoteId !== null && +selectedQuoteId !== 0) ? (
                  <h3 style={{fontWeight: "bold", color: "red"}}>
                    Products and prices related to Quote {selectedQuoteId}{" "}
                  </h3>
              ) : null}
              <div style={{padding: "10x"}}>
                <h3 style={{borderBottom: "2px dashed grey", padding: "5px" }}>
                  Product Details {}
                </h3>
                {loading ? (
                    <LoadingData />
                ) : (
                    <>
                      <OrderWeightIcons />
                      <OrderProductsTable />
                      <StageOneNextBackButtons />
                    </>
                )}
              </div>
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>
  );
}
